import type { ServerCredentialInfo, ServerDeploymentInfo } from '@/api/type-server.ts'

export class Deployment {
  resID: string
  name: string
  description: string
  gateway: ServerDeploymentInfo['gateway']
  runtimeEnv: ServerDeploymentInfo['runtimeEnv']
  totalCostCent: number
  ttlSeconds: number
  maxReplicas: number
  scalingMode: 0 | 1
  concurrencyPerReplica: number
  maxPendingRequests: number
  credentials: ServerCredentialInfo[]

  constructor(props: ServerDeploymentInfo) {
    this.resID = props.resID
    this.name = props.name
    this.description = props.description
    this.gateway = { ...props.gateway }
    this.runtimeEnv = {
      ...props.runtimeEnv,
      systemEnv: { ...props.runtimeEnv.systemEnv },
      hardwareEnv: {
        ...props.runtimeEnv.hardwareEnv,
        resource: { ...props.runtimeEnv.hardwareEnv.resource },
      },
    }
    this.totalCostCent = props.totalCostCent
    this.ttlSeconds = props.ttlSeconds
    this.maxReplicas = props.maxReplicas
    this.scalingMode = props.scalingMode ?? 0
    this.concurrencyPerReplica = props.concurrencyPerReplica ?? 0
    this.maxPendingRequests = props.maxPendingRequests ?? 0
    this.credentials = props.credentials || []
  }
}
